var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card-item", attrs: { id: "client-timeline" } },
    [
      _c("section", { staticClass: "columns is-vcentered" }, [
        _c(
          "div",
          {
            staticClass:
              "column has-text-centered is-hidden-tablet is-hidden-desktop pt-0 pb-1",
          },
          [
            _c("span", { staticClass: "current-step" }, [
              _vm._v(_vm._s(_vm.$t(_vm.steps[_vm.activeStep].name))),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "column pt-1" },
          [
            _c(
              "b-steps",
              {
                attrs: {
                  animated: _vm.isAnimated,
                  rounded: _vm.isRounded,
                  "has-navigation": _vm.hasNavigation,
                  "label-position": _vm.labelPosition,
                  "mobile-mode": _vm.mobileMode,
                },
                model: {
                  value: _vm.activeStep,
                  callback: function ($$v) {
                    _vm.activeStep = $$v
                  },
                  expression: "activeStep",
                },
              },
              _vm._l(_vm.steps, function (step) {
                return _c("b-step-item", {
                  key: step.name,
                  attrs: {
                    label: _vm.$t(step.name),
                    clickable: _vm.clickable,
                    type: { "is-success": step.status },
                    "icon-pack": "fas",
                    icon: _vm.icon(step),
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }